var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseLayout',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_vm._t("main")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }